import { getSelectors, NotificationsCatalogData } from '@repo/core'
import { RootState } from '../../store/types'

export const {
  accountsNotificationSelector,
  commonNotificationSelector,
  positionNotificationSelector,
  toolsNotificationSelector,
  userNotificationSelector,
} = (() => {
  return [
    {
      name: 'accountsNotificationSelector',
      getRootPath: (state: RootState) => state.catalogs.notifications.accounts,
    },
    {
      name: 'commonNotificationSelector',
      getRootPath: (state: RootState) => state.catalogs.notifications.common,
    },
    {
      name: 'positionNotificationSelector',
      getRootPath: (state: RootState) => state.catalogs.notifications.position,
    },
    {
      name: 'toolsNotificationSelector',
      getRootPath: (state: RootState) => state.catalogs.notifications.tools,
    },
    {
      name: 'userNotificationSelector',
      getRootPath: (state: RootState) => state.catalogs.notifications.user,
    },
  ].reduce(
    (acc, { name, getRootPath }) => ({
      ...acc,
      [name]: getSelectors<NotificationsCatalogData, RootState>({
        getRootPath,
      }),
    }),
    {} as Record<string, ReturnType<typeof getSelectors<NotificationsCatalogData, RootState>>>,
  )
})()
